module.exports = __webpack_public_path__ + "img/5_60.92dc3b24.png";